import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { LoginService } from "../../../login/services/login.service";
import { DistrictAdministrationService } from "../../../siteadmin/services/districtadministration.service";
import { ChangePasswordRequest } from "./shared/ChangePasswordRequest";
import { DataService_MySettings } from "./shared/data.service";
import { DefaultPagePreferenceRequest } from "./shared/DefaultPagePreferenceRequest";
import { EmailUpdateUserEmailRequest } from "./shared/EmailUpdateUserEmailRequest";
import * as shajs from "sha.js";

@Component({
	selector: "app-my-settings-dialog",
	templateUrl: "./my-settings-dialog.component.html",
	styleUrls: ["./my-settings-dialog.component.css"],
})
export class MySettingsDialogComponent implements OnInit {
	constructor(
		private userService: UserService,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private settingsService: DataService_MySettings,
		private loginService: LoginService,
		private districtadministrationService: DistrictAdministrationService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.loadPasswordInstructions();

		this.loadEmail();
		this.loadEmailProviders();

		this.loadSecurityPrefs();

		this.loadMFASettings();

		this.loadDefaultPage();

		this.loadPortalAppQR();
	}

	/////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////

	user: any;

	EMail: any;
	EMailAddress: any = "";
	EmailProvider: any;
	lstEmail: any = [];

	EmailError: any = "";

	ConfirmPasswordWhenChanging: boolean = true;
	OldPassword: any = "";
	NewPassword: any = "";
	ConfirmPassword: any = "";

	PasswordError: any = "";

	EmailLoaded1: any = false;
	EmailLoaded2: any = false;
	UpdatingEmail: any = false;

	PasswordUpdating: any = false;

	LoadingMFA: any = true;
	MFACanEdit: any = false;
	MFAEnabled: any = false;
	MFAUpdating: any = false;
	MFAMessage: any = "";
	MFAError: any = "";

	MFARegistered: any = false;
	MFAResetting: any = false;

	LoadingDefaultPage: any = false;
	DefaultPageUpdating: any = false;
	DefaultPageResetting: any = false;
	DefaultPageAlreadySet: any = false;
	SelectedDefaultPage: any;
	lstDefaultPages: any = [];

	DefaultPageError: any = "";

	//
	// Security Prefs
	//
	LoadingPrefs: any = false;

	PasswordExpID: any = 0;
	PasswordReuseID: any = 0;
	MinLength: any = "3";
	ContainNumbers: any = false;
	ContainSpecialChars: any = false;
	ChangeAfterAdminReset: any = false;
	LockoutAttemptsID: any = 0;

	PasswordInstructions: string = "";

	PortalAppTurnedOn: boolean = false;
	StaffPortalQRB64: string = "";

	/////////////////////////////////////////////////////

	/////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////
	loadEmail() {
		var result = this.settingsService.EmailSelectByUser(this.user.userID);
		result.subscribe(
			(response) => {
				var resp: any = response;

				if (resp.length > 0) {
					this.EMail = response[0];

					var StopInd = String(this.EMail.EMailAddress).indexOf("@");

					this.EMailAddress = String(this.EMail.EMailAddress).substring(0, StopInd);
				}

				this.EmailLoaded1 = true;
			},
			(error) => {}
		);
	}

	loadEmailProviders() {
		var result = this.settingsService.EmailProviderSelectList(this.user.userID);
		result.subscribe(
			(response) => {
				this.lstEmail = response;

				if (this.lstEmail.length > 0) {
					this.EmailProvider = this.lstEmail[0];
				}

				this.EmailLoaded2 = true;
			},
			(error) => {}
		);
	}

	loadSecurityPrefs() {
		//
		// Based on District Admin/Security Settings
		//
		this.LoadingPrefs = true;

		var result = this.districtadministrationService.LoadDistrictSecurityPreferenceList();
		result.subscribe(
			(response) => {
				var prefs: any = response;

				for (var i = 0; i < prefs.length; i++) {
					var next = prefs[i];

					if (next.KeyName == "PasswordExpiration") {
						this.PasswordExpID = Number(next.KeyValue);
					} else if (next.KeyName == "PasswordReuse") {
						this.PasswordReuseID = Number(next.KeyValue);
					} else if (next.KeyName == "PasswordLength") {
						this.MinLength = Number(next.KeyValue);
					} else if (next.KeyName == "PasswordNumbers") {
						this.ContainNumbers = Number(next.KeyValue) == 1 ? true : false;
					} else if (next.KeyName == "PasswordSpecialChars") {
						this.ContainSpecialChars = Number(next.KeyValue) == 1 ? true : false;
					} else if (next.KeyName == "PasswordReset") {
						this.ChangeAfterAdminReset = Number(next.KeyValue) == 1 ? true : false;
					} else if (next.KeyName == "PasswordLockoutAttempts") {
						this.LockoutAttemptsID = Number(next.KeyValue);
					} else if (next.KeyName == "ConfirmPasswordWhenChanging") {
						if (next.KeyValue == "0" || String(next.KeyValue).toLowerCase() == "f" || String(next.KeyValue).toLowerCase() == "false") {
							this.ConfirmPasswordWhenChanging = false;
						}
					}
				}

				this.LoadingPrefs = false;
			},
			(error) => {
				this.LoadingPrefs = false;
			}
		);
	}

	loadMFASettings() {
		this.LoadingMFA = true;

		var result = this.settingsService.UserSettingsSelect(this.user.userID);
		result.subscribe(
			(response) => {
				var resp: any = response;

				if (resp.length > 0) {
					var Data = response[0];

					if (Data != undefined) {
						this.MFACanEdit = Data.MFACanEdit;
						this.MFAEnabled = Data.Enabled;
						this.MFAMessage = Data.Message;
						this.MFARegistered = Data.Registered;
					}
				}

				this.LoadingMFA = false;
			},
			(error) => {
				this.LoadingMFA = false;
			}
		);
	}

	loadDefaultPage() {
		this.LoadingDefaultPage = true;

		var result = this.settingsService.DefaultPageInfoSelect(this.user.userID);
		result.subscribe(
			(response: any) => {
				this.DefaultPageAlreadySet = response.DefaultPageAlreadySet;
				this.lstDefaultPages = response.lstDefaultPages;

				this.SelectedDefaultPage = this.lstDefaultPages[0];

				if (this.DefaultPageAlreadySet == true) {
					for (var z = 0; z < this.lstDefaultPages.length; z++) {
						var next = this.lstDefaultPages[z];

						if (next.Selected == true) {
							this.SelectedDefaultPage = next;
							break;
						}
					}
				}

				this.LoadingDefaultPage = false;
			},
			(error) => {
				this.LoadingDefaultPage = false;
			}
		);
	}

	loadPasswordInstructions() {
		var result = this.loginService.PasswordInstructionSelect();
		result.subscribe(
			(response: any) => {
				this.PasswordInstructions = response.str;
			},
			(error) => {}
		);
	}

	loadPortalAppQR() {
		var result = this.settingsService.PortalAppUserSelect();
		result.subscribe(
			(response: any) => {
				this.PortalAppTurnedOn = response.PortalAppTurnedOn;
				this.StaffPortalQRB64 = response.StaffPortalQRB64;
			},
			(error) => {}
		);
	}

	/////////////////////////////////////////////////////

	/////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////
	onEmailUpdate() {
		this.UpdatingEmail = true;

		if (this.EMailAddress == "") {
			this.EmailError = "Enter an email";

			this.UpdatingEmail = false;

			return;
		}

		var newAddress = this.EMailAddress + "@" + this.EmailProvider.EmailProviderEmailInfo;

		let parms: EmailUpdateUserEmailRequest = {
			UserID: this.user.userID,
			EmailID: this.EMail.EMailID,
			EMailAddress: newAddress,
		};

		var result = this.settingsService.EmailUpdateUserEmail(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//
					// Success Dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Email was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.UpdatingEmail = false;
						},
					});
				} else {
					//
					// Fail Dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update your Email",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.UpdatingEmail = false;
						},
					});
				}
			},
			(error) => {
				this.UpdatingEmail = false;
			}
		);
	}

	onPasswordUpdate() {
		this.PasswordUpdating = true;

		//
		// Based on Login/PasswordResetByAdmin
		//
		this.PasswordError = "";

		//
		// Error handling
		//

		// Null
		if (this.ConfirmPasswordWhenChanging == true && this.OldPassword == "") {
			this.PasswordError = "Enter your old password";

			this.PasswordUpdating = false;

			return;
		}
		if (this.NewPassword == "") {
			this.PasswordError = "Enter a password";

			this.PasswordUpdating = false;

			return;
		} else if (this.ConfirmPassword == "") {
			this.PasswordError = "Confirm password";

			this.PasswordUpdating = false;

			return;
		} else if (String(this.NewPassword) != String(this.ConfirmPassword)) {
			this.PasswordError = "Passwords don't match";

			this.PasswordUpdating = false;

			return;
		}
		//
		// Check prefs
		//
		else if (this.NewPassword.length < Number(this.MinLength) || this.ConfirmPassword.length < Number(this.MinLength)) {
			this.PasswordError = "Password must be at least " + String(this.MinLength) + " characters";

			this.PasswordUpdating = false;

			return;
		} else if (this.GetNumberCount(String(this.NewPassword)) == 0 && this.ContainNumbers) {
			this.PasswordError = "Password must have at least 1 number";

			this.PasswordUpdating = false;

			return;
		} else if (this.GetSpecialChar(String(this.NewPassword)) == 0 && this.ContainSpecialChars) {
			this.PasswordError = "Password must have at least 1 special character";

			this.PasswordUpdating = false;

			return;
		}

		//
		// Confirm Old Password (if Preference is on)
		//
		if (this.ConfirmPasswordWhenChanging == true) {
			this.CheckOldPassword();
		} else {
			// Don't care if password was already used
			this.ProcessChangePassword();
		}
	}

	CheckOldPassword() {
		//
		// Create Request
		//
		var PasswordHash = String(shajs("sha256").update(this.OldPassword).digest("hex")).toUpperCase();

		let parms: ChangePasswordRequest = {
			UserID: this.user.userID,
			Password: PasswordHash,
		};

		//
		// Call SP to confirm password
		//

		var result = this.settingsService.CheckExistingPassword(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == false) {
					this.PasswordError = response.ErrorMessage;

					this.PasswordUpdating = false;

					return;
				} else {
					//
					// Continue
					//
					this.ProcessChangePassword();
				}
			},
			(error) => {
				//
				// Continue
				//
				this.ProcessChangePassword();
			}
		);
	}

	ProcessChangePassword() {
		//
		// Create Request
		//
		var PasswordHash = String(shajs("sha256").update(this.NewPassword).digest("hex")).toUpperCase();

		let parms: ChangePasswordRequest = {
			UserID: this.user.userID,
			Password: PasswordHash,
		};

		//
		// Call SP
		//

		var result = this.settingsService.ChangePassword(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//
					// Success dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Password was changed successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.PasswordUpdating = false;
							this.OldPassword = "";
							this.NewPassword = "";
							this.ConfirmPassword = "";
						},
						reject: () => {
							this.PasswordUpdating = false;
							this.OldPassword = "";
							this.NewPassword = "";
							this.ConfirmPassword = "";
						},
					});
				} else {
					//
					// Fail dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Error processing reset password request",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.PasswordUpdating = false;
							return;
						},
						reject: () => {
							this.PasswordUpdating = false;
							return;
						},
					});
				}
			},
			(error) => {
				this.PasswordUpdating = false;

				return;
			}
		);
	}

	onMFAUpate() {
		if (this.MFACanEdit == false) {
			return;
		}

		var SuccessMsg: string = "MFA settings were updated successfully. ";
		if (this.MFAEnabled == true) {
			//
			// Turned On + Not Registered Yet
			//
			if (this.MFARegistered == false) {
				SuccessMsg += "Next time you log in you will be asked to set up and app like Microsoft Authenticator or Google Authenticate. ";
				SuccessMsg +=
					"After entering your username and password you will get instructions for setting up the app and you will get a QR code for you to register (these are unique for each user.) ";
				SuccessMsg += "Whenever you log in and MFA is turned on you will need to enter a code from the app before logging in.";
			}
			//
			// Already Registered, Reset it if you can't access the app
			//
			else {
				SuccessMsg += "NOTE: You are already registered for MFA so you will be asked to enter a code from your Authenticator App when you log in. ";
				SuccessMsg +=
					"If you need a NEW QR CODE or need to set up the app again, press the Reset MFA Registration button and you will receive a new code and instructions next time you try to log in.";
			}
		} else {
			SuccessMsg +=
				"You have opted-out of MFA. This means you won''t have to type in a code when you log in UNLESS the district or one of the schools you have access to turns the MFA feature on.";
		}

		var result = this.settingsService.UserMFAUpdate(this.user.userID, this.MFAEnabled == true ? 1 : 0);
		result.subscribe(
			(response) => {
				if (response) {
					//
					// Success dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: SuccessMsg,
						header: "Success",
						icon: "fa",
						accept: () => {
							this.MFAUpdating = false;
						},
						reject: () => {
							this.MFAUpdating = false;
						},
					});
				} else {
					//
					// Fail dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Error updating MFA preferences",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.MFAUpdating = false;
							return;
						},
						reject: () => {
							this.MFAUpdating = false;
							return;
						},
					});
				}
			},
			(error) => {
				this.MFAUpdating = false;

				return;
			}
		);
	}

	onResetMFA() {
		this.confirmationService.confirm({
			key: "confirmsettings",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "You are about to reset your MFA Account. Next time you login you will receive a new QR code to scan. Do you want to continue?",
			header: "Confirm Reset MFA",
			icon: "fa",
			accept: () => {
				this.FinishResetMFA();
			},
		});
	}

	FinishResetMFA() {
		this.MFAResetting = true;

		var result = this.settingsService.UserResetMFA(this.user.userID);
		result.subscribe(
			(response) => {
				if (response) {
					//
					// Success dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"Your MFA Registration was reset. Next time you log in you will get a new QR code and instructions to set up your MFA app. Your old entry in your Authenticator app will no longer work and should be deleted.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadMFASettings();
							this.MFAResetting = false;
							this.MFAUpdating = false;
						},
						reject: () => {
							this.loadMFASettings();
							this.MFAResetting = false;
							this.MFAUpdating = false;
						},
					});
				} else {
					//
					// Fail dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Error resetting your MFA registration",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.MFAResetting = false;
							this.MFAUpdating = false;
							return;
						},
						reject: () => {
							this.MFAResetting = false;
							this.MFAUpdating = false;
							return;
						},
					});
				}
			},
			(error) => {
				this.MFAResetting = false;
			}
		);
	}

	onDefaultPageUpate() {
		this.DefaultPageError = "";

		if (this.SelectedDefaultPage == null) {
			this.DefaultPageError = "Select which page should show up after you log in";
			return;
		}

		this.DefaultPageUpdating = true;

		var parms: DefaultPagePreferenceRequest = {
			UserID: this.user.userID,
			ApplicationItemID: this.SelectedDefaultPage.ID,
		};

		var result = this.settingsService.UserUpdateDefaultPage(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//
					// Success dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Preference was updated successfully. When you log in you will be redirect to: " + this.SelectedDefaultPage.Desc,
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadDefaultPage();
							this.DefaultPageUpdating = false;
						},
						reject: () => {
							this.loadDefaultPage();
							this.DefaultPageUpdating = false;
						},
					});
				} else {
					//
					// Fail dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Error updating preferences",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.DefaultPageUpdating = false;
							return;
						},
						reject: () => {
							this.DefaultPageUpdating = false;
							return;
						},
					});
				}
			},
			(error) => {
				this.DefaultPageResetting = false;
			}
		);
	}

	onResetDefaultPage() {
		this.confirmationService.confirm({
			key: "confirmsettings",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				"You are about to reset your default page preference. This means you will be redirected to a page specified by the district or the default home page. Do you want to continue?",
			header: "Confirm Reset Default Page",
			icon: "fa",
			accept: () => {
				this.FinishResetDefaultPage();
			},
		});
	}

	FinishResetDefaultPage() {
		this.DefaultPageResetting = true;

		var result = this.settingsService.UserResetDefaultPage(this.user.userID);
		result.subscribe(
			(response) => {
				if (response) {
					//
					// Success dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message:
							"Your default page preference was reset. If your school district has set a default page you will be redirect to it next time you login. If there isn't a district preference you will be redirected to the normal dashboard.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadDefaultPage();
							this.DefaultPageResetting = false;
						},
						reject: () => {
							this.loadMFASettings();
							this.DefaultPageResetting = false;
						},
					});
				} else {
					//
					// Fail dialog
					//
					this.confirmationService.confirm({
						key: "settings",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Error resetting your default page preference",
						header: "ERROR",
						icon: "fa",
						accept: () => {
							this.DefaultPageResetting = false;
							return;
						},
						reject: () => {
							this.DefaultPageResetting = false;
							return;
						},
					});
				}
			},
			(error) => {
				this.DefaultPageResetting = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////////////////

	/////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////

	GetNumberCount(pass: String) {
		var count = 0;

		for (var i = 0; i < pass.length; i++) {
			var next = pass.substr(i, 1);

			if (!Object.is(Number(next), NaN)) {
				count++;
			}
		}

		return count;
	}

	GetSpecialChar(pass: String) {
		var count = 0;
		var letters = "abcdefghijklmnopqrstuvwxyz";

		for (var i = 0; i < pass.length; i++) {
			var next = pass.substr(i, 1);

			//Not a number and not a letter
			if (Object.is(Number(next), NaN) && letters.indexOf(next.toLowerCase()) == -1) {
				count++;
			}
		}

		return count;
	}

	/////////////////////////////////////////////////////
}
